import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'

import { NestedTreeControl } from '@angular/cdk/tree'
import { MatDialog } from '@angular/material/dialog'
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { OfflineService } from '../../../../shared/offline.service'
import { CommandeSettingsArticles, CommandeSettingsDeliveries } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { Commande, CommandeDetails } from '../../shared/commande'
import { CommandeService } from '../../shared/commande.service'
import { Inventaire, LigneInventaire, Lingerie } from '../../shared/inventaire'
import { BesoinValidateDialogComponent } from './besoin-validate-dialog/besoin-validate-dialog.component'

interface InventaireNode {
  id: number
  commande: Commande
  lingerie: Lingerie
  statut: any
  date_modification: Date
  children?: InventaireNode[]
}

@Component({
  selector: 'app-besoin-edit',
  templateUrl: './besoin-edit.component.html',
  styleUrls: ['./besoin-edit.component.scss']
})
export class BesoinEditComponent implements OnInit, OnDestroy {

  commandeSettingsArticles: CommandeSettingsArticles[]
  commandeDetails: CommandeDetails
  commandeId: string

  loading: boolean = false
  currentClient: Client

  curDay: string
  curDayNumber: number = 1

  commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  enabledConditionnement: boolean = false

  jourLingerieDotationList: Inventaire[] = []

  treeControl = new NestedTreeControl<InventaireNode>(node => node.children)
  dataSource = new MatTreeNestedDataSource<Inventaire>()

  isOnline: boolean = true

  dotationsJour

  subClient: Subscription

  isValidated: boolean = false

  constructor(
    private commandeSettingsService: CommandeParamSettingsService,
    private clientService: ClientService,
    private commandeService: CommandeService,
    private snackBar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private offlineService: OfflineService
  ) {
    moment().locale('fr')
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  hasChild = () => true

  ngOnInit(): void {
    this.loading = true;
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.route.queryParams.subscribe(params => {
        this.commandeId = params.id
        this.getCommandeDetails(this.currentClient, this.commandeId)
      })
    })

  }

  getCommandeDetails(currentClient: Client, commandeId: string) {
    this.commandeService.getCommandeDetails(commandeId).subscribe(async data => {
      this.commandeDetails = data
      if (data.statut.code == "V") {
        this.isValidated = true
      }
      this.getDotations(currentClient.id, commandeId)
      this.getArticles(this.currentClient)
    })
  }

  getDotations(clientId, commandeId) {
    let day = (new Date(this.commandeDetails.date_livraison)).getDay()
    this.commandeService.getClientDotationsJour(clientId, day).subscribe(data => {
      this.dotationsJour = data
      this.getInventaires(commandeId)
    })
  }

  getInventaires(commandeId) {
    this.commandeService.getInventairesCommande(commandeId).subscribe(inventaires => {
      this.dataSource.data = inventaires
      this.dataSource.data.forEach(inventaire => {
        let dotationsLingerie = this.dotationsJour.find(value => value.lingerie.id == inventaire.lingerie.id)
        if (dotationsLingerie && dotationsLingerie.dotations.length > 0) {
          dotationsLingerie.dotations.forEach(value => {
            let article = value.article
            let dotationValue = value.quantite
            let indexArticle = inventaire.inventaire_lignes.findIndex(ligne => ligne.article.id === article.id)
            if (indexArticle == -1) {
              let articleObj = { id: article.id, designation: article.designation }
              inventaire.inventaire_lignes.push({ article: articleObj, dotation: dotationValue, restant: null, qte_commande: 0 })
            } else {
              inventaire.inventaire_lignes[indexArticle].dotation = dotationValue
            }
          })
        }
      })
    })
  }

  getArticles(client: Client) {
    this.commandeSettingsService.getCommandSettingsArticles(client.id).subscribe(data => {
      this.commandeSettingsArticles = data.filter(article => article.is_commandable === true)
      this.getClientDeliveries()
    })
  }

  ngOnDestroy() {
    this.snackBar.dismiss()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  updateInventaire(ligne: LigneInventaire, event: any) {
    if (!ligne.dotation) {
      if (event.target.value > 0) {
        this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
      }
      event.target.value = 0
    }
    else if (+event.target.value > ligne.dotation) {
      event.target.value = ligne.dotation
      this.notificationService.notif("Quantité saisie supérieure à la dotation", 'warn')
    }
    else if (+event.target.value < 0) {
      event.target.value = 0
    }
    ligne.restant = event.target.value !== "" ? +event.target.value : null
    ligne.qte_commande = ligne.restant != null ? ligne.dotation - ligne.restant : 0
  }

  omit_not_number(e) {
    var k
    document.all ? k = e.keyCode : k = e.which
    return ((k > 96 && k < 106) || k == 8 || k == 32 || (k >= 48 && k <= 57))
  }

  getClientDeliveries() {
    this.commandeSettingsService.getCommandDeliveries(this.currentClient.id).subscribe(
      (data) => {
        this.commandeSettingsDeliveries = data
        this.getClientConditionnement()
      }
    )
  }

  refuse() {
    this.router.navigate(['/escli/linge-hebergement/list'])
  }

  getDotation(articleId, dotations) {
    let dotations_jour = dotations.filter(ligne => ligne.jour_livraison == new Date(this.commandeDetails.date_livraison).getDay())
    if (dotations_jour.length > 0) {
      let dotation = dotations_jour[0].dotations.filter(value => value.article.id == articleId)
      if (dotation.length > 0) {
        return Math.ceil(+(dotation[0].quantite))
      }
    }
    return 0
  }

  openDialog(): void {
    if (!this.isOnline) {
      this.notificationService.notif("Vous ne pouvez pas valider l'inventaire en Mode Hors Ligne", "warn")
    } else {
      if (this.dataSource.data.every(inventaire => inventaire.statut['code'] == 'R')) {
        const dialogRef = this.dialog.open(BesoinValidateDialogComponent, {
          data: { commandeId: this.commandeId }
        })
        dialogRef.beforeClosed().subscribe(result => {
          if (result) {
            this.router.navigate(['/escli/linge-hebergement/list']).then(value => {
              this.notificationService.notif("Les inventaires ont été validés", "notif")
            })
          }
        }, err => console.log(err), () => {
        })
      } else {
        this.notificationService.notif("Vous ne pouvez pas valider les inventaires car ils ne sont pas tous renseignés", "warn")
      }
    }
  }

  getClientConditionnement() {
    this.commandeSettingsService.getCommandConditionnement(this.currentClient.id).subscribe(data => {
      this.enabledConditionnement = data?.enabled_conditionnement ?? false
      this.loading = false
    })
  }

  getJourLingerieDotation(lingerie) {
    if (this.jourLingerieDotationList.length > 0) {
      let dotations = this.jourLingerieDotationList.filter(value => value.lingerie.id == lingerie.id)

      if (dotations.length > 0) {
        return dotations[0].inventaire_lignes
      }
    }
    return []
  }

  saveInventaire(inventaire) {
    if (!this.isOnline) {
      this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " va être enregistré automatiquement quand vous serez en ligne", "warn", 6000)
    }

    this.offlineService
      .isOnlinePromise()
      .then(res => {
        if (res) {
          inventaire.enabled_coeff = this.currentClient.enabled_coeff
          this.commandeService.postInventaire(inventaire).subscribe(data => {
            inventaire.statut = data.statut
            this.notificationService.notif("L'inventaire de la lingerie " + inventaire.lingerie.libelle + " a été enregistré", "notif")
          })
        }
      })
  }

  getConditionnement(article) {
    let article_el = this.commandeSettingsArticles.find(art => art.article.id == article.id)
    if (article_el) {
      return article_el.qte_conditionnement
    }
    return null
  }
}
